import { useAuth } from '@cmg/auth';
import { useMemo } from 'react';

import { useFeatureToggles } from '../config';

export const useMatchingCmgEntityKeys = () => {
  const { oidcUserCmgEntityKey, oidcUserLinkedCmgEntityKeys } = useAuth();
  const { isLinkedEntityAccessOn } = useFeatureToggles();

  return useMemo(() => {
    if (isLinkedEntityAccessOn && oidcUserLinkedCmgEntityKeys?.length) {
      return oidcUserLinkedCmgEntityKeys;
    }
    return oidcUserCmgEntityKey ? [oidcUserCmgEntityKey] : [];
  }, [oidcUserCmgEntityKey, oidcUserLinkedCmgEntityKeys, isLinkedEntityAccessOn]);
};

export const useLineupMatchingCmgEntityKeys = (
  managers: readonly { readonly cmgEntityKey: string }[]
) => {
  const matchingCmgEntityKeys = useMatchingCmgEntityKeys();

  return useMemo(
    () =>
      matchingCmgEntityKeys.filter(key =>
        managers.some(({ cmgEntityKey }) => cmgEntityKey === key)
      ),
    [matchingCmgEntityKeys, managers]
  );
};
